function waitForjQuery(callback) {
    if (window.jQuery) {
        callback();
    } else {
        setTimeout(function() {
            waitForjQuery(callback);
        }, 50);
    }
}

waitForjQuery(function() {
  jQuery(document).ready(function() {    
    /* Load images immediately */
    let images = document.body.querySelectorAll('img[data-srcset]');
    if (images) {
      for (let i = 0; i < images.length; i++) {
        const element = images[i];
        const srcset = element.getAttribute('data-srcset');
        element.setAttribute('srcset', srcset);
        element.setAttribute('data-rimg', 'loaded')
        jQuery(element).next('div[data-rimg-canvas]').remove();
      }
    }

    /* Click on product slider prev/next button */
    jQuery(document).on('click', '.flickity-prev-next-button', function() {
      let galleryIndex = jQuery('button.product-gallery--media-thumbnail[data-gallery-selected="true"]').attr('data-gallery-index');
      const isNext = jQuery(this).hasClass('next');
      if (isNext) {
        const max = jQuery('.gallery-navigation--scroller button').length - 1;
        if (galleryIndex < max) {
          galleryIndex++;
        }
      } else {
        if (galleryIndex > 0) {
          galleryIndex--;  
        }
      }
      jQuery('.product-gallery--media-thumbnail[data-gallery-index="' + galleryIndex + '"]').trigger('click');
    });

    /* Translate elements to English */
    const colorMap = new Map([
      ['altweiß', 'old white'],
      ['aquamarin', 'aquamarine'],
      ['blau', 'blue'],
      ['braun', 'brown'],
      ['elfenbein', 'ivory'],
      ['feuerrot', 'fire red'],
      ['flieder', 'lilac'],
      ['gelb', 'yellow'],
      ['gold', 'gold'],
      ['goldgelb', 'golden yellow'],
      ['grün', 'green'],
      ['hellblau', 'light blue'],
      ['königsblau', 'royal blue'],
      ['lindgrün', 'lime green'],
      ['matt braun', 'dull brown'],
      ['matt nachtblau', 'matt midnight blue'],
      ['matt petrol', 'matte petrol'],
      ['matt schwarz', 'matt black'],
      ['matt weiß', 'matte white'],
      ['matte rose', 'matt rose'],
      ['orange', 'orange'],
      ['perlgrau', 'pearl gray'],
      ['petrol', 'petrol'],
      ['rose', 'rose'],
      ['rot', 'red'],
      ['schwarz', 'black'],
      ['weiß', 'white']
    ]);    
  
    const translateFilterOptions = function() {
      /* Translate 'Availability' filter option */
      jQuery('div.gf-option-515504 span.gf-label').each(function() {
        const label = jQuery(this);
        const value = label.html().replace('Tage', 'days').replace('Wochen', 'weeks');
        label.html(value);
      });      
  
      /* Translate 'Color' filter option */
      jQuery('div.gf-option-521845 span.gf-label').each(function() { 
        const label = jQuery(this);
        const value = label.html();
        if (colorMap.has(value)) {
           label.html(colorMap.get(value));
        }
      });    
    };
    
    if (Shopify.locale !== 'de') {
      const body = document.querySelector('body');
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.target.nodeName == 'BODY') {
            translateFilterOptions();
          }
  
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeName != '#text') {
              translateFilterOptions();
            }
            
            /* Translate cookie consent */
            if ((node.nodeType === Node.ELEMENT_NODE) && node.classList.contains('cc-window')) {
              jQuery('.cc-message').html('This website uses cookies to ensure you get the best experience on our website. <a aria-label="learn more about cookies" role="button" tabindex="0" class="cc-link" href="https://hedwig-bollhagen.myshopify.com/pages/privatsphare" rel="noopener noreferrer nofollow" target="_blank">Learn more</a>');
              jQuery('.cc-btn.cc-allow').html('Allow cookies');
              jQuery('.cc-btn.cc-deny').html('Deny');
              return;
            }
          });
        });
      });
      observer.observe(body, { childList: true, subtree: true });    
    }


    jQuery('.utility-bar .shopify-cross-border').wrap('<li class="utility-bar"></li>').parent().appendTo('nav.site-navigation > ul');
  
    jQuery('.navmenu-id-cookie-einstellungen a').on('click', function (e) {
      document.querySelector('.cc-revoke') && document.querySelector('.cc-revoke').click();
      e.stopPropagation();
      e.preventDefault();
      return false;
    });
    
    jQuery('div.collection--description').each(function() {
      const content = jQuery(this).html();
      const position = content.search('<!-- Sub section -->'); 
      if (position > 0) {
          const contentBeforeComment = content.substr(0, position);
          const contentAfterComment = content.substr(contentBeforeComment.length, content.length - position);
          jQuery(this).html(contentBeforeComment);
          const description = jQuery('<div class="collection--description rte"></div>').html(contentAfterComment);
          jQuery('div.collection-footer').append(description);
      }
    });
    
    function doTextTruncate() {
      const innerWidth = window.innerWidth;
      
      jQuery('.text-truncate').each(function() {
        const readMore = jQuery(this).attr('data-read-more');
        const readLess = jQuery(this).attr('data-read-less');
              
        const height = jQuery(this).height();
        let maxChars = jQuery(this).attr('data-max-chars');
              
        if (! maxChars) {
          maxChars = 600;
          if (innerWidth >= 1024 && innerWidth < 1280) {
            maxChars = 300;
          } else if (innerWidth < 768) {
            maxChars = 200;
          }
        }
        
        let content = jQuery(this).attr('data-content');
        if (! content) {
          content = jQuery(this).html();
          jQuery(this).attr('data-content', content);
        }
          
        if(content.length > maxChars) {
          const c = content.substr(0, maxChars).split(' ').slice(0, -1).join(' ');
          const h = content.substr(c.length, content.length - c.length);
          const html = c + '<span><span class="text-truncate--hidden" style="display: none;">' + h + '</span> <a href="#" class="text-truncate--more-link" data-read-more="' + readMore + '" data-read-less="' + readLess + '">' + readMore + '</a></span>';
          jQuery(this).html(html);
        }
      });
  
      jQuery('.text-truncate--more-link').click(function() {
        let moreLink = jQuery(this);  
        const readMore = moreLink.attr('data-read-more');
        const readLess = moreLink.attr('data-read-less');
        
        if (moreLink.hasClass('text-truncate--less')) {
          moreLink.removeClass('text-truncate--less');
          moreLink.html(readMore);
        } else {
          moreLink.addClass('text-truncate--less');
          moreLink.html(readLess);
        }
        moreLink.parent().find('.text-truncate--hidden').toggle();
        return false;
      });  
    }
  
    doTextTruncate();
    window.addEventListener('resize', doTextTruncate);
    jQuery('.collection--text').css('visibility', 'visible');
    
    jQuery('#shopify-section-template--15882824515805__1655559171ea4ca3a8 a.featured-collection__button').click(function(event) {
      let moreLink = jQuery(this); 
      let container = moreLink.parent('.featured-collection__container');
      if (! container.find('ul.featured-collection__content').hasClass('flickity-enabled')) {
        if (container.hasClass('show')) {
          return true;
        } else {
          container.addClass('show');
          moreLink.html('Zur Form');
        }
        event.preventDefault();
        return false;
      }
      
      return true;
    });
    
    jQuery('.options-selection__option-decor a > span.more').parent().click(function(event) {
      let container = jQuery("#shopify-section-template--15882824515805__1655559171ea4ca3a8");
      jQuery([document.documentElement, document.body]).animate({
          scrollTop: container.offset().top - 150
      }, 100, 'swing', function() {
        setTimeout(function(){ 
          container.find('a.featured-collection__button').first().trigger('click');
        }, 100);
      });
      
      event.preventDefault();
      return false;
    });
  
    jQuery('.site-footer-wrapper .newsletter .newsletter-input:after').click(function(event) {
      jQuery(this).closest('form').submit();
    });
    
    document.addEventListener('animationstart', function (e) {
      if (e.animationName === 'fade-in') {
        e.target.classList.add('faded-in');
      }
    });
  
    document.addEventListener('animationend', function (e) {
      if (e.animationName === 'fade-out') {
        e.target.classList.remove('faded-in');
      }
    });
  
    jQuery('form[action="/search2"]').on('submit', function() {
      const queryInput = jQuery(this).find('input[name="q"]'); 
      let query = queryInput.val();
      query += ' tag:collection-show';
      queryInput.val(query);
      return true;
    });
  
    const hideBundles = function() {
      const bundles = jQuery('div[id^=rbr-bundle-]');
      bundles.each(function(index, bundle) {
        if (index == 1 && jQuery('a.rbr-bundle-more').length == 0) {
          jQuery(bundle).after('<a href="#" class="button button-primary rbr-bundle-more">Flexible Sets anzeigen</a>')
        }
        if (index >= 1) {
          jQuery(bundle).hide();
        }
      });    
    };
    hideBundles();
    
    document.addEventListener('bundles:created', function (e) {
      let targetNode = document.querySelector('#rbr-container-element-false');
      if (targetNode) {
        jQuery('.product-details').append(jQuery('#rbr-container-element-false'));   
        
        const bundleObserver = new MutationObserver((mutationsList, observer) => {
          for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
              const addedNodes = Array.from(mutation.addedNodes);
              addedNodes.forEach(node => {
                if (node.nodeType === Node.ELEMENT_NODE) {
                  hideBundles();
                }
              });
            }
          }
        });
        bundleObserver.observe(targetNode, { childList: true, subtree: true });        
      }

      targetNode = document.querySelector('#rbr-container-element-true');
      if (targetNode) {
        // jQuery('.quantity-selector').hide();
      }
    });
  
    jQuery(document).on('click', 'a.rbr-bundle-more', function (e) {
      jQuery('div[id^=rbr-bundle-]:hidden, div.product-sets--outer:hidden').fadeIn();
      jQuery(this).hide();
      e.stopPropagation();
      e.preventDefault();
      return false;
    });
  });
});

window.addEventListener('cartcount:update', function (e) {
  // console.log(e);
});

window.addEventListener('globoFilterRenderCompleted', function (e) {
  const container = document.querySelector('#gf-grid');
  const matches = container.querySelectorAll('img[data-rimg="lazy"]');
  matches.forEach((item) => {
    let event = new CustomEvent('theme:rimg:watch', { bubbles: true });
    item.dispatchEvent(event);
  });
});

window.addEventListener('globoFilterRenderSearchCompleted', function (e) {
  const container = document.querySelector('#glFilter-search-popup');
  const matches = container.querySelectorAll('img[data-rimg="lazy"]');
  matches.forEach((item) => {
    let event = new CustomEvent('theme:rimg:watch', { bubbles: true });
    item.dispatchEvent(event);
  });
});

